export const isSandbox = () => {
	const env = process.env.REACT_APP_BIGCOMMERCE_ENV || "";

    return env.toLowerCase() !== 'live'
};
